import React, {FC, useEffect, useMemo, useRef, useState} from "react";
import {DefaultButton, LangBlockWrapper, TableSortWrapper, TeamEditLabel} from "../styles";
import {LangTitleBox} from "../../../components/LangTitleBox/LangTitleBox";
import {ProjectEditPageGridRow} from "../../projectEdit/styles";
import {ProjectEditPageGridInput} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {Input} from "@brg/input";
import {API, Endpoints, Group, GroupAPI, Lang} from "@brg/api";
import {Colors, CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, useToasts} from "@brg/ui";
import {MagicBoxRow} from "../../project/components/toolsStyles";
import {cloneValue, filterMaxLength, setTextByLang} from "../TeamEdit";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import {useGetDisciplineInfo} from "../../../hooks/api/LMS/useGetDisciplineInfo";
import {InfoIcon} from "../../../components/InfoIcon/InfoIcon";
import {createEmptyLangObject} from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {LMSModuleCover} from "../../../components/LMSModuleCover/LMSModuleCover";
import {ProjectCardTitle} from "../../../components/projectCard/styles";
import ColorPicker from "../../projectEdit/components/ColorPicker";
import {ColorPickerVertical} from "../../../components/ColorPickerVertical/ColorPickerVertical";
import {JustTable} from "../../../../_competition/components/style";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import {DottedIcon} from "../../../icons/DottedIcon";
import EditIcon24 from "../../../icons/EditIcon24";
import {CreateLinkTo} from "../../../constants/linkTo";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import styled from "styled-components";
// import {types} from "sass";

const InterLogo = styled(FlexBox)`
  font-weight: 600;
  display: block;
  word-break: break-word;
  margin-bottom: 0px;
  text-align: left;
  font-family: Inter;
  font-size: 60px;
  line-height: 70px;
  font-style: normal;
  color: ${Colors.galBlack100};
  letter-spacing: -0.01em !important;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 51px;
    line-height: 60px;
  }

  @media (max-width: 568px) {
    font-size: 42px;
    line-height: 50px;
  }

  @media (max-width: 430px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

export const TeamDisciplineEdit: FC<{ discipline?: any, onUpdate: (val: any) => void, onStatusSet: (val: string) => void; }> = ({ discipline, onUpdate, onStatusSet }) => {

    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const { t, i18n } = useTranslation()
    const { info, isLoading } = useGetDisciplineInfo(discipline?.id, discipline?.teamId)
    const modules = useMemo(() => API.toLang(info?.modules || [], i18n.language) as any, [info, i18n])
    const [name, setName] = useState<any>(createEmptyLangObject('', ['en', 'ru']))
    const [color, setColor] = useState<any>(discipline?.color)
    const toasts = useToasts()
    const currentLang = (name || [])?.find((name: any) => name?.currentLang)?.currentLang || 'ru';
    const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({ ...i, currentLang: lang === 'ru' ? 'en' : 'ru' })));
    const isMobile = useIsMobile();
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const isMob = useBreakpoint(LayoutConst.screen.s);
    const throttle = useRef<any>();

    useEffect(() => {
        if (info?.discipline?.name) setName(info?.discipline?.name)
    }, [info]);

    useEffect(() => {
        if (throttle.current) {
            clearTimeout(throttle.current);
            throttle.current = null;
        }
        if (isLoading) return;
        throttle.current = setTimeout(() => {
            onStatusSet(t('saving'));
            //@ts-ignore
            const copy = { ...info?.discipline};
            //@ts-ignore
            copy.name = cloneValue(name);
            //@ts-ignore
            copy.color = color;

            API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/UpdateDiscipline')
                .body(copy)
                .post()
                .release()
                .then((res: any) => {
                    setTimeout(() => onStatusSet(t('editing_saved')), 1000)
                    onUpdate(Date.now())
                })

        } , 1000)
    }, [name, color, isLoading]);

    const onEdit = (id: any) => {
        window.open(CreateLinkTo.project(id), '_blank')
    }

    const onCreate = () => {
        window.open(process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.projectCreateByOrganization(discipline?.teamId || ''), '_blank')
    }

    return (
        <>
            <InterLogo offsetBottom={16}>
                {t('my_courses.discipline_edit')}
            </InterLogo>
            <LangBlockWrapper direction="row" directionMobile={isS ? 'column' : 'row'}>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    orientation="wide"
                    label={t('teams.adminPage.fields.disciplines_name')}
                    useLangSwitcher
                    value={name}
                    onChange={(ev: any, lang?: string) => setName(setTextByLang(name, lang ?? 'ru', filterMaxLength(ev.target.value, 100, toasts, t)))}
                />
            </LangBlockWrapper>
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.cover_color')}
                    fixedHeight
                />
                <ProjectEditPageGridInput isTeamEdit>
                    <LMSModuleCover style={{width: '100%'}} color={color} title={<ProjectCardTitle style={{height: '228px'}}>{t('my_courses.homework_page.module')} 1<br/>{Lang(name, currentLang)}</ProjectCardTitle>}/>
                    <FlexBox offsetLeft={16} style={{width: 'fit-content'}}>
                        <ColorPickerVertical value={color} onChange={setColor}/>
                    </FlexBox>
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
            <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.modules')}
                    fixedHeight
                />
                <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
                    <ProjectEditPageGridInput  isTeamEdit direction={!!modules?.length ? 'column' : 'row'} style={{flexDirection: isMobile ? 'column' : 'inherit'}}>
                        {!!modules?.length && (
                            <JustTable isTeamEdit>
                                <thead>
                                <tr>
                                    <th style={{width: '45%', paddingTop: 0 }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                                    <th style={{width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0 }}></th>
                                    {!isS && (
                                        <th style={{width: isS ? 0 : '30%', paddingTop: 0}}></th>
                                    )}
                                </tr>
                                </thead>
                                {modules.map((module: any, index: number) => {
                                    //@ts-ignore
                                    return (
                                            <tr>
                                                <td style={{ width: isMobile ? '100%' :'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                                    <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                                        <CommonInput 
                                                            type={INPUT_TYPES.text}
                                                            value={module?.title}
                                                            disable={true}
                                                            onChange={() => null}
                                                        />
                                                    </TableSortWrapper>
                                                </td>
                                                <td style={{ width: isS ? '56px' : '336px' }}>
                                                    <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                        {isS ? (
                                                            <EditIcon24 onClick={() => onEdit(module?.projectId)}/>
                                                        ) : (
                                                            <DefaultButton wh={181} whMob={157}  style={{ marginBottom: 5 }} onClick={() => onEdit(module?.projectId)}>
                                                                {t('teams.adminPage.buttons.edit')}
                                                            </DefaultButton>
                                                        )}
                                                    </FlexBox>
                                                </td>
                                            </tr>
                                    );
                                })}
                            </JustTable>
                        )}
                        <FlexBox style={{ marginTop: !modules?.length ? 0 : isSmallMob ? 10 : 24}}>
                            <DefaultButton wh={195} whMob={195} onClick={() => {
                                onCreate();
                            }}>
                                <PlusSvg />
                                {t('teams.adminPage.buttons.create')}
                            </DefaultButton>
                        </FlexBox>
                    </ProjectEditPageGridInput>
                </FlexBox>
            </ProjectEditPageGridRow>
        </>
    );
};import React, {FC, useEffect, useMemo, useRef, useState} from "react";
import {DefaultButton, LangBlockWrapper, TableSortWrapper, TeamEditLabel} from "../styles";
import {LangTitleBox} from "../../../components/LangTitleBox/LangTitleBox";
import {ProjectEditPageGridRow} from "../../projectEdit/styles";
import {ProjectEditPageGridInput} from "../../../../_deziiign/books/pages/BookEdit/styles";
import {Input} from "@brg/input";
import {API, Endpoints, Group, GroupAPI, Lang} from "@brg/api";
import {Colors, CommonInput, CommonLabel, FlexBox, INPUT_TYPES, useBreakpoint, useIsMobile, useToasts} from "@brg/ui";
import {MagicBoxRow} from "../../project/components/toolsStyles";
import {cloneValue, filterMaxLength, setTextByLang} from "../TeamEdit";
import {LayoutConst} from "../../../../core";
import {useTranslation} from "react-i18next";
import {useGetDisciplineInfo} from "../../../hooks/api/LMS/useGetDisciplineInfo";
import {InfoIcon} from "../../../components/InfoIcon/InfoIcon";
import {createEmptyLangObject} from "../../../components/__ADDONS__/__SAFEAPI__/Empty";
import {LMSModuleCover} from "../../../components/LMSModuleCover/LMSModuleCover";
import {ProjectCardTitle} from "../../../components/projectCard/styles";
import ColorPicker from "../../projectEdit/components/ColorPicker";
import {ColorPickerVertical} from "../../../components/ColorPickerVertical/ColorPickerVertical";
import {JustTable} from "../../../../_competition/components/style";
import SortableList, {SortableItem, SortableKnob} from "react-easy-sort";
import {DottedIcon} from "../../../icons/DottedIcon";
import EditIcon24 from "../../../icons/EditIcon24";
import {CreateLinkTo} from "../../../constants/linkTo";
import { ReactComponent as PlusSvg } from "../../projectEdit/close.svg";
import styled from "styled-components";
// import {types} from "sass";

const InterLogo = styled(FlexBox)`
  font-weight: 600;
  display: block;
  word-break: break-word;
  margin-bottom: 0px;
  text-align: left;
  font-family: Inter;
  font-size: 60px;
  line-height: 70px;
  font-style: normal;
  color: ${Colors.galBlack100};
  letter-spacing: -0.01em !important;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 51px;
    line-height: 60px;
  }

  @media (max-width: 568px) {
    font-size: 42px;
    line-height: 50px;
  }

  @media (max-width: 430px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

export const TeamDisciplineEdit: FC<{ discipline?: any, onUpdate: (val: any) => void, onStatusSet: (val: string) => void; }> = ({ discipline, onUpdate, onStatusSet }) => {

    const isS = useBreakpoint(LayoutConst.screen.s - 1);
    const { t, i18n } = useTranslation()
    const { info, isLoading } = useGetDisciplineInfo(discipline?.id, discipline?.teamId)
    const modules = useMemo(() => API.toLang(info?.modules || [], i18n.language) as any, [info, i18n])
    const [name, setName] = useState<any>(createEmptyLangObject('', ['en', 'ru']))
    const [color, setColor] = useState<any>(discipline?.color)
    const toasts = useToasts()
    const currentLang = (name || [])?.find((name: any) => name?.currentLang)?.currentLang || 'ru';
    const onLocalLangChange = (arr: any[], lang: string, callback: (test: any[]) => void) => callback(arr?.map((i: any) => ({ ...i, currentLang: lang === 'ru' ? 'en' : 'ru' })));
    const isMobile = useIsMobile();
    const isSmallMob = useBreakpoint(LayoutConst.screen.xsm);
    const isMob = useBreakpoint(LayoutConst.screen.s);
    const throttle = useRef<any>();

    useEffect(() => {
        if (info?.discipline?.name) setName(info?.discipline?.name)
    }, [info]);

    useEffect(() => {
        if (throttle.current) {
            clearTimeout(throttle.current);
            throttle.current = null;
        }
        if (isLoading) return;
        throttle.current = setTimeout(() => {
            onStatusSet(t('saving'));
            //@ts-ignore
            const copy = { ...info?.discipline};
            //@ts-ignore
            copy.name = cloneValue(name);
            //@ts-ignore
            copy.color = color;

            API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/UpdateDiscipline')
                .body(copy)
                .post()
                .release()
                .then((res: any) => {
                    setTimeout(() => onStatusSet(t('editing_saved')), 1000)
                    onUpdate(Date.now())
                })

        } , 1000)
    }, [name, color, isLoading]);

    const onEdit = (id: any) => {
        window.open(CreateLinkTo.project(id), '_blank')
    }

    const onCreate = () => {
        window.open(process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.projectCreateByOrganization(discipline?.teamId || ''), '_blank')
    }

    return (
        <>
            <InterLogo offsetBottom={16}>
                {t('my_courses.discipline_edit')}
            </InterLogo>
            <LangBlockWrapper direction="row" directionMobile={isS ? 'column' : 'row'}>
                <CommonInput 
                    type={INPUT_TYPES.text}
                    orientation="wide"
                    label={t('teams.adminPage.fields.disciplines_name')}
                    useLangSwitcher
                    value={name}
                    onChange={(ev: any, lang?: string) => setName(setTextByLang(name, lang ?? 'ru', filterMaxLength(ev.target.value, 100, toasts, t)))}
                />
            </LangBlockWrapper>
            <ProjectEditPageGridRow style={{marginTop: isS ? 24 : 40}} isTeamEdit>
                <CommonLabel 
                    label={t('teams.adminPage.fields.cover_color')}
                    fixedHeight
                />
                <ProjectEditPageGridInput isTeamEdit>
                    <LMSModuleCover style={{width: '100%'}} color={color} title={<ProjectCardTitle style={{height: '228px'}}>{t('my_courses.homework_page.module')} 1<br/>{Lang(name, currentLang)}</ProjectCardTitle>}/>
                    <FlexBox offsetLeft={16} style={{width: 'fit-content'}}>
                        <ColorPickerVertical value={color} onChange={setColor}/>
                    </FlexBox>
                </ProjectEditPageGridInput>
            </ProjectEditPageGridRow>
            <ProjectEditPageGridRow align="flex-start" alignMobile="flex-start" style={{marginTop: isS? 24 : 40}} isTeamEdit >
                <CommonLabel 
                    label={t('teams.adminPage.fields.modules')}
                    fixedHeight
                />
                <FlexBox direction="column" directionMobile="column" widthMobile={'100%'}>
                    <ProjectEditPageGridInput  isTeamEdit direction={!!modules?.length ? 'column' : 'row'} style={{flexDirection: isMobile ? 'column' : 'inherit'}}>
                        {!!modules?.length && (
                            <JustTable isTeamEdit>
                                <thead>
                                <tr>
                                    <th style={{width: '45%', paddingTop: 0 }}>{t('teams.adminPage.additionalFields.td_name')}</th>
                                    <th style={{width: '22%', whiteSpace: 'nowrap', textAlign: 'center', paddingTop: 0 }}></th>
                                    {!isS && (
                                        <th style={{width: isS ? 0 : '30%', paddingTop: 0}}></th>
                                    )}
                                </tr>
                                </thead>
                                {modules.map((module: any, index: number) => {
                                    //@ts-ignore
                                    return (
                                            <tr>
                                                <td style={{ width: isMobile ? '100%' :'auto', padding: isMobile ? '8px 12px 8px 0px' : 'inherit' }}>
                                                    <TableSortWrapper direction={'row'} directionMobile="row" align={'center'}>
                                                        <CommonInput 
                                                            type={INPUT_TYPES.text}
                                                            value={module?.title}
                                                            disable={true}
                                                            onChange={() => null}
                                                        />
                                                    </TableSortWrapper>
                                                </td>
                                                <td style={{ width: isS ? '56px' : '336px' }}>
                                                    <FlexBox direction={'row'} directionMobile="row" gx={isS ? 0 : 24} gxMobile={isS ? 0 : 24} widthMobile={'100%'} justifyMobile={isS ? 'end' : 'start'}>
                                                        {isS ? (
                                                            <EditIcon24 onClick={() => onEdit(module?.projectId)}/>
                                                        ) : (
                                                            <DefaultButton wh={181} whMob={157}  style={{ marginBottom: 5 }} onClick={() => onEdit(module?.projectId)}>
                                                                {t('teams.adminPage.buttons.edit')}
                                                            </DefaultButton>
                                                        )}
                                                    </FlexBox>
                                                </td>
                                            </tr>
                                    );
                                })}
                            </JustTable>
                        )}
                        <FlexBox style={{ marginTop: !modules?.length ? 0 : isSmallMob ? 10 : 24}}>
                            <DefaultButton wh={195} whMob={195} onClick={() => {
                                onCreate();
                            }}>
                                <PlusSvg />
                                {t('teams.adminPage.buttons.create')}
                            </DefaultButton>
                        </FlexBox>
                    </ProjectEditPageGridInput>
                </FlexBox>
            </ProjectEditPageGridRow>
        </>
    );
};